<template>
  <div class="Dashboard">    
     <MenuEncabezado/>
     <MenuLateral/>

    <div class="content-wrapper">
     <transition name="fade" mode="out-in">
       <router-view/>
     </transition>
    </div>

    <!-- Control Sidebar -->
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->
  </aside>
  <!-- /.control-sidebar -->

   <!-- Main Footer -->
  <footer class="main-footer">
    <strong>Copyright &copy; 2020 Arendal.</strong>
    All rights reserved.
    <div class="float-right d-none d-sm-inline-block">
      <b>Version</b> 1.0
    </div>
  </footer>

 
  </div>
</template>

<script>
// @ is an alias to /src
import MenuEncabezado from '../components/Navegacion/MenuEncabezado'
import MenuLateral from '../components/Navegacion/MenuLateral'

export default {
  name: 'Dashboard',
  components: {
    MenuEncabezado,
    MenuLateral
  }
}
</script>

<style>

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateX(2em);
}

.fade-enter-active, .fade-leave-active {
   transition: all .3s ease;
}

</style>
